import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormHelperText,
} from "@mui/material";
import { useField } from "formik";

import at from "helpers/at";
import React from "react";
import styles from "./checkboxfield.module.scss";

export interface CheckboxFieldProps {
  /**Label for the checkbox */
  label: any;
  /**Custom class */
  className?: string;
  /**Rest of the props */
  getFieldValue?: (value: boolean) => void;
  disabled?: boolean;
  [x: string]: any;
}

export default function CheckboxField(props: CheckboxFieldProps) {
  const {
    label,
    name,
    getFieldValue,
    disabled,
    onClick,
    // Formik props are accepted for backwards compatibility, but must not be
    // forwarded to the FormControl DOM root by MUI.
    isValid: _isValid,
    dirty: _dirty,
    unregisterField: _unregisterField,
    registerField: _registerField,
    getFieldProps: _getFieldProps,
    getFieldMeta: _getFieldMeta,
    getFieldHelpers: _getFieldHelpers,
    validateOnBlur: _validateOnBlur,
    validateOnChange: _validateOnChange,
    validateOnMount: _validateOnMount,
    values: _values,
    errors: _errors,
    touched: _touched,
    setFieldValue: _setFieldValue,
    setFieldTouched: _setFieldTouched,
    setFieldError: _setFieldError,
    setValues: _setValues,
    setTouched: _setTouched,
    setErrors: _setErrors,
    handleChange: _handleChange,
    handleBlur: _handleBlur,
    handleSubmit: _handleSubmit,
    validateForm: _validateForm,
    validateField: _validateField,
    value: _value,
    ...rest
  } = props;
  const [field, meta, helper] = useField(name);
  const { setValue } = helper;

  function renderHelperText() {
    const [touched, error] = at(meta, ["touched", "error"]);
    if (touched && error) {
      return <FormHelperText>{error}</FormHelperText>;
    }
  }

  function onChange(e: React.ChangeEvent) {
    setValue(!field.value);
  }
  field.checked = field.value;

  return (
    <FormControl {...rest} disabled={disabled}>
      <FormControlLabel
        value={field.value}
        checked={field.value}
        control={
          <Checkbox
            {...field}
            onChange={onChange}
            color="secondary"
            onClick={() => {
              getFieldValue && getFieldValue(Boolean(!field.checked));
              onClick && onClick();
            }}
            disabled={disabled}
          />
        }
        disabled={disabled}
        label={<div className={styles.label}>{label && `${label}`}</div>}
      />
      {renderHelperText()}
    </FormControl>
  );
}
